import $ from "jquery";
window.jQuery = $;
window.$ = $;

import "slick-carousel";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

let sliderInitialized = false;
let customArrowsUrl = '';

function ensureJQueryAndSlickLoaded(callback) {
  if (window.jQuery && typeof jQuery.fn.slick === "function") {
    callback();
  } else {
    console.log("jQuery or Slick not loaded yet, waiting...");
    setTimeout(() => ensureJQueryAndSlickLoaded(callback), 100);
  }
}

export function initSlider(arrowsUrl) {
  customArrowsUrl = arrowsUrl;
  ensureJQueryAndSlickLoaded(() => {
    if (sliderInitialized) {
      console.log("Slider already initialized, skipping");
      return;
    }

    const sliderElements = document.querySelectorAll("[data-slider-settings]");

    sliderElements.forEach((element) => {
      if (!element) return;
      let settings;
      if (element.classList.contains("wp-block-query")) {
        settings = JSON.parse(element.getAttribute("data-slider-settings"));
        element = element.querySelector(".wp-block-query > *:first-child:not(p,img)");
        if (!element) return;
        element.classList.add("figport-slider");
        element.classList.remove("columns-4");
        element.classList.remove("is-layout-grid");
      } else {
        settings = JSON.parse(element.getAttribute("data-slider-settings"));
      }

      if (!element || !settings) return;

      try {
        if (element.children.length > 0) {
          const slickSettings = {
            ...settings,
            slidesToShow: settings.slidesToShow,
            responsive: settings.responsive.map((breakpoint) => ({
              breakpoint: breakpoint.breakpoint,
              settings: {
                slidesToShow: breakpoint.slidesToShow,
                slidesToScroll: breakpoint.slidesToScroll,
              },
            })),
            prevArrow: `<button type="button" class="slick-prev"><img src="${customArrowsUrl}/prev-arrow.svg" alt="Previous"></button>`,
            nextArrow: `<button type="button" class="slick-next"><img src="${customArrowsUrl}/next-arrow.svg" alt="Next"></button>`,
          };

          $(element).slick(slickSettings);

          // Apply gap as padding to the first child of each slide item
          const children = element.querySelectorAll(".slick-slide");
          Array.from(children).forEach((child) => {
            const firstChild = child.firstElementChild;
            console.log("child", child);
            if (
              settings &&
              firstChild &&
              settings.gap &&
              settings.slidesToShow
            ) {
              firstChild.style.paddingRight = `${settings.gap}px`;
            }
          });
        } else {
          console.warn(
            "Slider element has no children, skipping initialization:",
            element
          );
        }
      } catch (error) {
        console.error("Error initializing slider:", error);
      }
    });

    sliderInitialized = true;
  });
}

// We'll remove the event listeners from here and handle them in frontend.js
